export default "__VITE_ASSET__BXb2_ZsI__"